module.exports = __webpack_public_path__ + "img/ic-chains-black.d5518216.svg";